import { put, select } from "redux-saga/effects"

import {
  checkAvailability,
  updatePricing,
  // fetchWarrantyOffers,
} from "../actions"

export default function* updatePriceAndShippingTime(action) {
  const state = yield select()
  if (!state.wizardUI.prefStore || action.pref === "gift") {
    return
  }

  try {
    var jsum = 0
    var diamond_sum = 0
    var jsalesum = 0
    var metal_sum = 0
    // var metal_sale_sum = 0
    // var ships_in = 0
    // Can't find this data prop in code anymore
    // var ships_in = Number(
    //   $(".item_shipping_info span").attr("data-base-ship-days")
    // )
    // if (isNaN(ships_in)) ships_in = 0
    var sku_regular_price = state.choices.sku ? state.choices.sku.price : null
    // var sku_regular_price = $("#sku_description_input").data('price');
    if (sku_regular_price) {
      // var sku_sale_price = $("#sku_description_input").data('sale-price');
      var sku_sale_price = state.choices.sku.sale_price
      if (sku_sale_price !== undefined && sku_sale_price !== null)
        jsalesum += Number(sku_sale_price)
      else jsalesum += Number(sku_regular_price)
      jsum += Number(sku_regular_price)
    }
    metal_sum = jsum
    // metal_sale_sum = jsalesum
    Object.keys(state.choices).forEach((key) => {
      const choice = state.choices[key]
      if (
        choice.disabled ||
        key == "sku" ||
        key == "box" ||
        choice.is_default ||
        (/^e\d$/.test(key) && !choice.value)
      ) {
        return
      }
      var data_price = choice.price
      if (data_price !== undefined) {
        var sale_price = choice.sale_price
        if (sale_price !== undefined && sale_price !== null) {
          jsalesum += Number(sale_price)
        } else {
          jsalesum += Number(data_price)
        }
        jsum += Number(data_price)
      }
      var sia = choice.sia
      if (sia !== undefined) {
        // ships_in += Number(sia)
      }
    })

    const isDiamondSelected =
      state.diamondSelector.selected_diamond?.price && state.choices?.s1?.value

    if (isDiamondSelected) {
      diamond_sum = state.diamondSelector.selected_diamond.price
    }

    var item_on_sale = jsum != jsalesum

    var surcharge_sum = jsum - metal_sum - diamond_sum
    // var surcharge_sale_sum = jsalesum - metal_sale_sum
    // var sku_metal = state.choices.sku ? state.choices.sku.value : null // $("#sku_description_input").val();
    var retail_markup = state.wizard.price_and_promo.rf
    var diamond_markup = 1 / 0.8

    var rsum =
      metal_sum * retail_markup +
      diamond_sum * diamond_markup +
      surcharge_sum * retail_markup

    // var display_retail_percent = ((rsum - jsum) / rsum) * 100
    // if ( style_code.indexOf("JWLN") == 0)
    //   rsum = jsum + parseFloat( $("#sku_description_input").data('price') ) + 1;

    var tax_rate = 1.0

    var price_to_display = (jsum == jsalesum ? jsum : jsalesum) * tax_rate
    var regular_price = jsum * tax_rate
    var onsale_price = jsalesum * tax_rate

    var retail_price = rsum * tax_rate
    var savings = (rsum - jsalesum) * tax_rate

    // New calculation
    if (jsum == jsalesum) {
      savings = retail_price - regular_price
    } else {
      //savings = (regular_price - onsale_price);
      savings = retail_price - onsale_price
    }

    yield put(
      updatePricing({
        on_sale: item_on_sale && savings > 0,
        price_to_display,
        regular_pricing: item_on_sale ? regular_price : null,
        retail_price: Math.round(retail_price),
        savings: parseInt(savings),
      })
    )

    // Check for size/sku availability on change
    // if (action.pref && $.inArray(action.pref, ['sku', 'sc', 'chead', 'cshank', 'sz']) > -1) {

    // Checking for all items (not just inventory) b/c of potential for different manufacturing
    // time for rose gold items
    // if (state.wizard.hasInventory) &&

    let hasNoEngravings = false
    // Don't hammer servers with availability
    // Only check availability if no other engravings are entered and current engraving field is either made empty or has a newly entered value
    if (action.pref?.[0] === "e") {
      hasNoEngravings = Object.keys(state.choices)
        .filter(
          (pref) => pref[0] === "e" && pref !== "ef" && pref !== action.pref
        )
        .every((pref) => state.choices[pref].value === "")
    }
    if (
      action.pref?.[0] !== "e" ||
      (hasNoEngravings &&
        (state.choices[action.pref].lastValue === "" ||
          action.data.value === ""))
    ) {
      yield put(checkAvailability(state))
    }

    // const pdpWarrantyExp = state.experiment.pdpWarranty.variant_id
    // if (pdpWarrantyExp === 1) {
    //   const fetchedPrice = state.wizard?.data?.warranty?.price
    //   // Fetch Warranty Offers
    //   if (!fetchedPrice || fetchedPrice !== price_to_display) {
    //     yield put(fetchWarrantyOffers(price_to_display))
    //   }
    // }
  } catch (e) {
    console.error(e)
  }
} // end updatePriceAndShippingTime
